import React, { useState, useEffect } from "react";
import {getAuthorization} from "../../../../axios/AxiosAut";
import Table, {
  AvatarCell,
  SelectColumnFilter,
  StatusPill,
} from "../../../table/Table"; // new
import { BsFillPersonPlusFill } from "react-icons/bs";
import { useLocation } from "react-router-dom";
import axiosInstance from "../../../../axios/Axios";
import Swal from "sweetalert2";
import "animate.css";

function AddStaffToGroupTableData() {
  const location = useLocation();
  const { state } = location;
  const GroupID = state;
  const [CompanyEmployees, setCompanyEmployees] = useState([]);
  const ActionHandler = (StaffID) => {
    axiosInstance
      .patch(`company/add_group_staff/${GroupID}/`, {
        staff_id: StaffID.id,
      })
      .then((res) => {
        GetCompanyEmployees() 
        Swal.fire({
          position: "top-end",
          title: "Staff Added!",
          showConfirmButton: false,
          timer: 3500,
          showClass: {
            popup: "animate__animated animate__fadeInRight",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutRight",
          },
          width: 300,
          color: "#FFFFFF",
          background: "#2A91D7",
          backdrop: `rgba(0,0,0,0)`,
        });
      })
      .catch((err) => {
        console.log("error in adding staff to the group", err);
      });
  };
  const GetCompanyEmployees=()=>{
    getAuthorization()
    .get("company/company_employees/")
    .then((res) => {
      setCompanyEmployees(res.data);
    })
    .catch((err) => {
      console.log("Error in getting user groups", err);
    });
  }
  useEffect(() => {
    //Get Company Employees
    GetCompanyEmployees()
  }, []);
  const data = CompanyEmployees;
  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "full_name",
        Cell: AvatarCell,
        imgAccessor: "profile_picture",
      },
      {
        Header: "Job Role",
        accessor: "job_role",
      },
      {
        Header: "Action",
        // accessor: "action",
        id: "edit",
        accessor: "name",
        Cell: (value) => (
          <button onClick={() => ActionHandler(value.row.original)}>
            <div className="flex flex-row justify-center space-x-2">
              <BsFillPersonPlusFill size={25} color="#5DAD38" />
              <p className="text-green-100 text-sm mt-1.5">Add to group</p>
            </div>
          </button>
        ),
      },
    ],
    []
  );

  return (
    <div>
      <main className="max-w-full">
        <Table columns={columns} data={data} text="Undefined" />
      </main>
    </div>
  );
}

export default AddStaffToGroupTableData;
